<template>
  <div>
    <container>
      <div slot="left_box_content">
        <component :is="curLeftComponent"></component>
      </div>
      <div slot="right_box_content">
        <component :is="curRightComponent"></component>
      </div>
      <div slot="bottom_box_content">
        <div class="platform-buttom-list">
          <div v-for="tag in tagList" :key="tag.key" @click="handleChangeTag(tag.key)"
           :class="tagType===tag.key? 'bottom-button-active':'bottom-button'">
           {{tag.value}}
          </div>
        </div>

        <component v-if="curBottomComponent === 'bottom_OrderList'" :is="'bottom_OrderList'"></component>
        <component v-show="curBottomComponent !== 'bottom_OrderList'" :is="curBottomComponent"></component>
      </div>
      <div slot="bg_map">
        <component :is="curMapComponent"></component>
      </div>

    </container>
  </div>
</template>

<script>
import Container from '@/components/common/Container'
import { sysMixins } from '@/assets/mixins/sys'
// 引入store模块
import orderStoreModule from '@/store/modules/order'

export default {
  mixins: [sysMixins],
  components: {
    Container,
    centerComponent: () => import('@/components/order/Center'),
    // 左侧组件
    left_OrderCreate: () => import('@/components/order/left/Create_Saler'),
    left_OrderEdit: () => import('@/components/order/left/Edit2'),
    // 底部组件
    bottom_OrderList: () => import('@/components/order/bottom/List_Saler'),
    bottom_OrderEdit: () => import('@/components/order/bottom/Edit'),
    bottom_OrderDetail: () => import('@/components/order/bottom/Detail'),
    // 右侧组件
    salerOverviewComponent: () => import('@/components/overview/SalerOverview'),
    right_OrderEdit: () => import('@/components/order/right/Edit'),
    right_OrderDetail: () => import('@/components/order/right/Detail')
  },
  data () {
    return ({
      closePersonInfo: this.$store.getters.token.publisherSetting.personInfo, // 关闭个人能力
      tagType: 0,
      tagList: []
    })
  },
  created () {
    // 注册动态store模块
    if (!this.$store.hasModule('order')) {
      this.$store.registerModule('order', orderStoreModule)
      this.$store.commit('set_order_isManage', false)
    }
  },
  mounted () {
    if (this.closePersonInfo) {
      this.setRightComponent('')
      this.setShowRightBlock(false)
    } else {
      this.setRightComponent('salerOverviewComponent')
    }
    this.setBottomComponent('bottom_OrderList')
    this.setBottomHeight('90%')
    this.setShowLeftBlock(false)
    this.tagList = [
      { key: 1, value: '我的采购清单' }
    ]
    this.tagType = 1
  },
  methods: {
    clearPage () {
      // 清空地图标注
      this.$store.commit('set_order_stations', [])
      this.$store.commit('set_order_update_map', new Date())
      this.$store.commit('set_order_show_assets', [])
      this.$store.commit('set_order_defaultProduct', undefined)
    },
    handleChangeTag (val) {
      if (val === 1) {
        // this.loadPageComponent('create')
        this.tagType = 1
        this.$store.commit('set_order_pageType', 'list')
        this.setBottomComponent('bottom_OrderList')

        if (this.closePersonInfo) {
          this.setRightComponent('')
          this.setShowRightBlock(false)
        } else {
          this.setRightComponent('salerOverviewComponent')
        }

        if (this.curBottomHeight === '5px') {
          this.setBottomHeight('300px')
        }
      } else {
        this.$store.commit('set_order_pageType', val === 2 ? 'edit' : 'detail')
        // this.loadPageComponent(val === 2 ? 'edit' : 'detail')
      }
    },
    loadPageComponent (type) {
      if (type === 'edit') {
        this.setShowRightBlock(true)
        this.setRightComponent('right_OrderEdit')
        this.setShowLeftBlock(true)
        this.setLeftComponent('left_OrderEdit')
        this.setBottomHeight('300px')
        this.setBottomComponent('bottom_OrderEdit')
        this.setMapComponent('centerComponent')

        this.tagList = [
          { key: 1, value: '我的采购清单' },
          { key: 2, value: '编辑订单' }
        ]
        this.tagType = 2
      } else if (type === 'detail') {
        this.setShowRightBlock(true)
        this.setRightComponent('right_OrderDetail')
        this.setShowLeftBlock(false)
        this.setLeftComponent('')
        this.setBottomHeight('90%')
        this.setBottomComponent('bottom_OrderDetail')
        this.setMapComponent('centerComponent')

        this.tagList = [
          { key: 1, value: '我的采购清单' },
          { key: 3, value: '订单详情' }
        ]
        this.tagType = 3
      } else if (type === 'create') {
        this.setShowLeftBlock(true)
        this.setLeftComponent('left_OrderCreate')
        this.setBottomHeight('90%')

        if (this.closePersonInfo) {
          this.setRightComponent('')
          this.setShowRightBlock(false)
        } else {
          this.setRightComponent('salerOverviewComponent')
        }

        this.setMapComponent('')
        this.tagList = [
          { key: 1, value: '我的采购清单' }
        ]
        this.tagType = 1
      }
    }
  },
  computed: {
    pageType () {
      return this.$store.state.order ? this.$store.state.order.pageType : ''
    },
    orderId () {
      return this.$store.state.order ? this.$store.state.order.orderId : ''
    }
  },
  watch: {
    pageType (val) {
      if (val !== 'list') {
        this.clearPage()
        this.loadPageComponent(val)
      }
    },
    orderId (val) {
      this.clearPage()
    }
  },
  destroyed () {
    this.$store.commit('set_order_pageType', '')
    // 卸载动态store模块
    this.$store.unregisterModule('order')
    this.setShowLeftBlock(true)
    this.setShowMap(true)
    this.setShowRightBlock(true)
    this.setBottomHeight('300px')
    this.setLeftComponent('')
    this.setRightComponent('')
    this.setBottomComponent('')
    this.setMapComponent('')
    this.setLinkTagArray()
    this.setLinkRouterMaps()
    this.setActivedTagName('')
  }
}
</script>
